<style lang="less" scoped>
  .contain {
    display: flex;
    .item-contain {
      flex:1;
      margin: 0 5px;
    }
  }
</style>
<template>
  <div>
    <v-expand-transition>
      <div 
        v-if="expand"
        style="position:relative"
      >
        <v-divider />
        <VOverlayLoading
          :value="item_loading"
        />

        <v-card-text>
          <div
            v-for="(item,index) in child_items"
            :key="index"
          >
            <div class="contain">
              <div class="item-contain">
                <VTableCard 
                  :style="{
                    'margin-bottom':'10px'
                  }"
                  :value="item"
                  :fields="first_fields"
                >
                  <template v-slot:title>
                    <v-ripple-col
                      :md="12"
                      cols="12"
                    >
                      <span style="white-space:nowrap;font-weight: bold;">收款信息</span>
                    </v-ripple-col>
                  </template>
                  <template v-slot:account_title_id="{value}">
                    <v-ripple-col
                      :md="12"
                      cols="12"
                    >
                      <span style="white-space:nowrap">会计科目：</span>
                      <v-spacer />
                      <AccountTitle :id="value.account_title_id" />
                    </v-ripple-col>
                  </template>
                  <template v-slot:analysis_title_id="{value}">
                    <v-ripple-col
                      :md="12"
                      cols="12"
                    >
                      <span style="white-space:nowrap">分析科目：</span>
                      <v-spacer />
                      <AnalysisTitle :id="value.analysis_title_id" />
                    </v-ripple-col> 
                  </template>
                </VTableCard>
              </div>
              <div class="item-contain">
                <VTableCard 
                  :style="{
                    'margin-bottom':'10px'
                  }"
                  :value="item"
                  :fields="second_fields"
                  :md="12"
                >
                  <template v-slot:title>
                    <v-ripple-col
                      :md="12"
                      cols="12"
                    >
                      <span style="white-space:nowrap;font-weight: bold;">账户信息</span>
                    </v-ripple-col>
                  </template>
                  <template v-slot:account_title_id="{value}">
                    <v-ripple-col
                  
                      cols="12"
                    >
                      <span style="white-space:nowrap">会计科目：</span>
                      <v-spacer />
                      <AccountTitle :id="value.account_title_id" />
                    </v-ripple-col>
                  </template>
                  <template v-slot:analysis_title_id="{value}">
                    <v-ripple-col
                     
                      cols="12"
                    >
                      <span style="white-space:nowrap">分析科目：</span>
                      <v-spacer />
                      <AnalysisTitle :id="value.analysis_title_id" />
                    </v-ripple-col> 
                  </template>
                </VTableCard>
              </div>
              <div class="item-contain">
                <VTableCard 
                  :style="{
                    'margin-bottom':'10px'
                  }"
                  :value="item"
                  :fields="thrid_fields"
                  :md="12"
                >
                  <template v-slot:title>
                    <v-ripple-col
                      :md="12"
                      cols="12"
                    >
                      <span style="white-space:nowrap;font-weight: bold;">发票信息</span>
                    </v-ripple-col>
                  </template>
                  <template v-slot:account_title_id="{value}">
                    <v-ripple-col
                  
                      cols="12"
                    >
                      <span style="white-space:nowrap">会计科目：</span>
                      <v-spacer />
                      <AccountTitle :id="value.account_title_id" />
                    </v-ripple-col>
                  </template>
                  <template v-slot:analysis_title_id="{value}">
                    <v-ripple-col
                     
                      cols="12"
                    >
                      <span style="white-space:nowrap">分析科目：</span>
                      <v-spacer />
                      <AnalysisTitle :id="value.analysis_title_id" />
                    </v-ripple-col> 
                  </template>
                </VTableCard>
              </div>
            </div>
          </div>
        </v-card-text>
      </div>
    </v-expand-transition>
  </div>
</template>
<script>
  import VTableCard from '@/vuetify_custom/v-table-card'
  import VOverlayLoading from '@/vuetify_custom/v-overlay-loading';
  import { mapGetters } from 'vuex'
  import { util_api } from '@/libs/util_api'
  import InvoiceUtil from '@/views/invoice/libs/util';
  import receipt_card_mixins from '../mixins/receipt_card_mixins'
  import receipt_base from '../mixins/receipt_base'
  import AccountTitle from './account_title';
  import AnalysisTitle from './analysis_title';
  import VRippleCol from '../../../vuetify_custom/v-ripple-col';
  import { receipt_types, unit_types } from '../fields'
  import { http, getsafe} from '@/libs/util'
  const { fin_receipt_bill_items } = util_api
  export default {
    components: {
      'v-ripple-col': VRippleCol,
      VTableCard,
      VOverlayLoading,
      AccountTitle,
      AnalysisTitle
    },
    mixins:[receipt_base, receipt_card_mixins],
    props: {
      value: {
        type: Object
      },
      showAction: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {

      }
    },
    created() {
      this.toggleExpand()
    },
    computed: {
      ...mapGetters('async', ['receipt_bill_types', 'clients', 'banks', 'banks_hash', 'receipt_purposes']),
      banks_proxy() {
        return this.banks.map(t => ({
          ...t,
          bank_dis: `${t.bank}-${t.account}`
        }))
      },
      first_fields() {
        return [
          {
            key: 'title'
          },
          {
            label: '单据名称：',
            key: 'name',
            type: 'text_field',
          },
          {
            label: '业务日期：',
            key: 'handled_at',
            type: 'date_field'
          },
          {
            label: '项目组：',
            key: 'team_id',
            type: 'team_field'
          }, 
          {
            label: '单据类型：',
            key: 'bill_type',
            type: 'select_field',
            items: receipt_types,
            text_key: 'name',
            value_key: 'uid'
          },
          {
            label: '收款用途编号：',
            key: 'purpose_uid',
            type: 'select_field',
            text_key: 'name',
            value_key: 'kingdee_uid',
            items: this.receipt_purposes,
          },
          {
            label: '人民币总金额金额：',
            key: 'cny_total_amount',
            type: 'money_field',
          },
          {
            label: '会计科目：',
            key: 'account_title_id',
          },
          {
            label: '分析科目：',
            key: 'analysis_title_id',
          },
          {
            label: '备注：',
            key: 'remark',
            type: 'text_field',
          },
        ]
      },
      second_fields() {
        return [
          {
            key: 'title'
          },
          { 
            label: '收款银行：',
            key: 'receipt_bank_id',
            type: 'select_field',
            items: this.banks_proxy,
            text_key: 'bank_dis',
            value_key: 'id',
            textRender:({h, value}) => {
              const t = getsafe(this.banks_hash, `${value.receipt_bank_id}`, {})
              return h('span', {
                style: {
                  'text-align': 'right'
                }
              }, [`${t.bank}-${t.account}`]) 
            }
          },
          {
            label: '往来单位类型：',
            key: 'contact_unit_type',
            type: 'select_field',
            items: unit_types,
            text_key: 'name',
            value_key: 'uid'
          },
          {
            label: '来往单位：',
            key: 'contact_unit_name',
            type: 'text_field',
          },
          {
            label: '付款银行：',
            key: 'opposite_bank_name',
            type: 'text_field',
          },
          {
            label: '付款银行账户名：',
            key: 'opposite_account',
            type: 'text_field',
          },
          {
            label: '付款银行账号：',
            key: 'opposite_bank_number',
            type: 'text_field',
          },
       
        ]
      },
      thrid_fields() {
        return [
          {
            key: 'title'
          },
          {
            label: '发票类型：',
            key: 'invoice_type',
            type: 'select_field',
            items: InvoiceUtil.invoice_types,
            text_key: 'name',
            value_key: 'value'
          },
          {
            label: '税率：',
            key: 'tax_rate',
          },
          {
            label: '税额：',
            key: 'tax',
            type: 'money_field',
          },
        ]
      },
      first_col() {
        return [
          {
            label: '单据名称：',
            key: 'name',
            type: 'text_field',
          },
          {
            label: '单据类型：',
            key: 'bill_type',
            type: 'select_field',
            items: receipt_types.concat({
              uid: 'other',
              name: '其他'
            }),
            text_key: 'name',
            value_key: 'uid'
          },
          {
            label: '收款用途编号：',
            key: 'purpose_uid',
            type: 'select_field',
            items: this.receipt_purposes,
            text_key: 'name',
            value_key: 'kingdee_uid'
          },
          {
            label: '往来单位类型：',
            key: 'contact_unit_type',
            type: 'select_field',
            items: unit_types,
            text_key: 'name',
            value_key: 'uid'
          },
          {
            label: '来往单位：',
            key: 'contact_unit_name',
            type: 'text_field',
          },
          {
            label: '备注：',
            key: 'remark',
            type: 'text_field',
          },
        ]
      },
      second_col() {
        return [
          {
            label: '项目组：',
            key: 'team_id',
            type: 'team_field'
          }, 
          {
            label: '收款银行：',
            key: 'receipt_bank_id',
            type: 'select_field',
            items: this.banks,
            text_key: 'bank',
            value_key: 'id'
          },
          {
            label: '付款银行：',
            key: 'opposite_bank_name',
            type: 'text_field',
          },
          {
            label: '付款银行账号：',
            key: 'opposite_bank_number',
            type: 'text_field',
          },
          {
            label: '付款银行账户名：',
            key: 'opposite_account',
            type: 'text_field',
          },
          {
            label: '业务日期：',
            key: 'handled_at',
            type: 'text_field',
          },
        ]
      },
      thrid_col() {
        return [
          {
            label: '发票类型：',
            key: 'invoice_type',
            type: 'select_field',
            items: InvoiceUtil.invoice_types,
            text_key: 'name',
            value_key: 'value'
          },
          {
            label: '税率：',
            key: 'tax_rate',
          },
          {
            label: '税额：',
            key: 'tax',
            type: 'money_field',
          },
          {
            label: '人民币总金额金额：',
            key: 'cny_total_amount',
            type: 'money_field',
          },
          {
            label: '会计科目：',
            key: 'account_title_id',
          },
          {
            label: '分析科目：',
            key: 'analysis_title_id',
          },
        ]
      },
      childFields() {
        let first_index = 0
        let second_index = 0
        let thrid_index = 0
        const arr = []
        while (first_index < this.first_col.length || second_index < this.second_col.length || thrid_index < this.thrid_col) {
          arr.push(this.first_col[first_index] || {
            type: 'no_content'
          })
          arr.push(this.second_col[second_index] || {
            type: 'no_content'
          })
          arr.push(this.thrid_col[thrid_index] || {
            type: 'no_content'
          })
          first_index++
          second_index++
          thrid_index++
        }
        return arr
      },
    },
    methods: {
      toggleExpand() {
        this.expand = !this.expand
        if (!this.child_items.length) {
          this.item_loading = true
          http.get(fin_receipt_bill_items, {
            id: this.value.id
          }).then((res) => {
            this.child_items = res.items.map(i => ({
              ...this.value,
              ...i,
            }))
          }).finally(() => {
            this.item_loading = false
          })
        }
      }
    }
  }
</script>

